import {
  INotification,
  notificationEnums,
} from "@freetech/models/notifications";

const formatAmount = (amount: number) => `$${Math.abs(amount).toLocaleString()}`;

export const getStakeholderNotificationTitle = (
  notification: INotification
): string | undefined => {
  const { type, afterData } = notification;

  switch (type) {
    case notificationEnums.StakeholderNotificationType.STAKEHOLDER_INVOICE_RECIEVED:
      if (afterData && 'totalDollarAmountDue' in afterData) {
        return `New invoice received: ${formatAmount(afterData.totalDollarAmountDue)}`;
      }
      return "New invoice received";

    case notificationEnums.StakeholderNotificationType.STAKEHOLDER_INVOICE_PAID:
      if (afterData && 'totalDollarAmountDue' in afterData) {
        return `Invoice paid: ${formatAmount(afterData.totalDollarAmountDue)}`;
      }
      return "Invoice has been paid";

    case notificationEnums.StakeholderNotificationType.STAKEHOLDER_CSA_RECIEVED:
      if (afterData && 'projectName' in afterData) {
        return `New CSA received for: ${afterData.projectName}`;
      }
      return "New consulting services agreement received";

    case notificationEnums.StakeholderNotificationType.STAKEHOLDER_PAYMENT_CREATED:
      if (afterData && 'amount' in afterData) {
        return `Payment initiated: ${formatAmount(afterData.amount)}`;
      }
      return "Payment has been initiated";

    case notificationEnums.StakeholderNotificationType.STAKEHOLDER_PAYMENT_COMPLETED:
      if (afterData && 'amount' in afterData) {
        return `Payment completed: ${formatAmount(afterData.amount)}`;
      }
      return "Payment completed successfully";

    case notificationEnums.StakeholderNotificationType.STAKEHOLDER_PAYMENT_FAILED:
      if (afterData && 'amount' in afterData) {
        return `Payment failed: ${formatAmount(afterData.amount)}`;
      }
      return "Payment failed";

    case notificationEnums.StakeholderNotificationType.STAKEHOLDER_PAYMENT_REVERSED:
      if (afterData && 'amount' in afterData) {
        return `Payment reversed: ${formatAmount(afterData.amount)}`;
      }
      return "Payment has been reversed";

    default:
      return undefined;
  }
}; 